export interface ContractorBankAccountDto {
  id: string; // Guid
  bankName: string;
  accountNumberLast4: string;
  accountType: string;
  isVerified: boolean;
  isPrimary: boolean;
}
